import { FC } from 'react';
import type { DataTableColumn, DataTableDimensions } from '@/components/UI/DataTableV2/DataTable.model';
import { DataTableColumnHeader } from './DataTableColumnHeader';
import { useDataTable } from '../DataTableProvider';

interface StickyPinnedColumnHeadersProps {
  pinnedDataColumns: Array<DataTableColumn>;
  rowHeaderWidth: number;
  groupHeaderHeight: number;
  dimensions: DataTableDimensions;
}

export const StickyPinnedColumnHeaders: FC<StickyPinnedColumnHeadersProps> = ({
  pinnedDataColumns,
  rowHeaderWidth,
  groupHeaderHeight,
  dimensions,
}) => {
  const { dataTableService } = useDataTable();

  return (
    <>
      {pinnedDataColumns.map((column, index) => {
        const columnIndex = dataTableService.toIndexColumn(column.id);
        if (columnIndex === undefined) {
          return null;
        }

        return (
          <DataTableColumnHeader
            key={column.id}
            columnIndex={columnIndex}
            positionOffset={{
              x: rowHeaderWidth + index * dimensions.cellWidth,
              y: groupHeaderHeight,
            }}
          />
        );
      })}
    </>
  );
};
